import * as React from 'react';
import { AvatarBadge } from 'components/Avatar';
import { contactabilityStyles } from 'components/ContactabilityBadge';
import { CoinColor } from 'components/Coin';
import { GlyphName } from '@remind/r101-glyphs';
import { ContactabilityStatus } from 'globalTypes';

export type Props = {
  hoverable?: boolean;
  status: ContactabilityStatus | undefined;
};

function AvatarContactabilityBadge(props: Props) {
  const { status } = props;

  if (!status) {
    return null;
  }

  const styles = contactabilityStyles[status];

  if (!styles) {
    console.error('AvatarContactabilityBadge tried to get styles for nonexistent status');
    return null;
  }

  return (
    <AvatarBadge
      tooltipCopy={props.hoverable ? styles.copy : null}
      backgroundColor={styles.backgroundColor as CoinColor}
      iconColor="white"
      iconName={styles.iconName as GlyphName}
    />
  );
}

export default AvatarContactabilityBadge;
